import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { useCheckoutStoreContext } from '../../context';
import { ICheckoutDependencies } from 'src/mobx/checkoutStore/types';
import { localeStore } from 'src/mobx/localesStore';
import Input from 'src/view/components/Controls/Input/Input';
import Text, { TEXT } from 'src/view/components/Text/Text';

const CheckoutCustomerInfo: React.FC = observer((): JSX.Element => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const changeUserInfo = useCallback(
    (field: keyof ICheckoutDependencies['user']) => (event: React.ChangeEvent<HTMLInputElement>) => {
      checkoutStore.changeUserInfo(field, event.target.value);
    },
    []
  );

  return (
    <>
      {/* customer name */}
      <div className="d-flex align-items-center mb-3">
        <Text type={TEXT.ORDER_FIELD} text="hint_name" required />
        <Input
          error={checkoutStore.validatorErrors.customer_name}
          onChange={changeUserInfo('name')}
          placeholder={localeStore.t('hint_name')}
          value={checkoutStore.dependencies.user.name}
          className="input-mini family-medium text-size-16 text-elipsis"
        />
      </div>
      {/* customer email */}
      <div className="d-flex align-items-center mb-3">
        <Text type={TEXT.ORDER_FIELD} text="hint_email_id" className={checkoutStore.validatorErrors.customer_email ? 'mb-6' : ''} />
        <Input
          error={checkoutStore.validatorErrors.customer_email}
          onChange={changeUserInfo('email')}
          placeholder={localeStore.t('hint_email_id')}
          value={checkoutStore.dependencies.user.email}
          className="input-mini family-medium text-size-16 text-elipsis"
          errorMessage={localeStore.t('toast_email_invalid')}
        />
      </div>
    </>
  );
});

export default CheckoutCustomerInfo;
